module.exports = __webpack_public_path__ + "assets/img/xygl__d_7.ce3d3b24.png";